import React from 'react';
import { Menu, Transition } from '@headlessui/react';

import { Fragment, useState } from 'react';
// import mixpanel from '../../lib/mixpanel';

import { Dialog } from '@headlessui/react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import storageService from '../../lib/storageService';

const DownloadExtensionPrompt = ({ show = false, setShow, toolLink }) => {
  return (
    <Transition.Root show={!!show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setShow}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                <div>
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100">
                    <ArrowDownTrayIcon
                      className="h-7 w-7 text-indigo-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-5 select-none">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium text-gray-900"
                    >
                      Chrome Extension Needed
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        You'll need to install our Chrome Extension to use our
                        in-app assistant
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6 flex flex-col">
                  <button
                    type="button"
                    className="active:scale-95 inline-flex justify-center w-full rounded-md border-0 px-4 py-2 bg-indigo-600 text-sm font-medium text-white hover:bg-indigo-700 transition-all duration-200 ease-in-out focus:outline-none outline-none select-none"
                    onClick={async () => {
                      await storageService.snoozeExtensionPrompt();
                      window.open(
                        'https://chrome.google.com/webstore/detail/startscreen-assistant/hiejpkfamempjjeocoeiblphhhgaddon',
                        '_blank'
                      );
                      setShow(false);

                      // mixpanel.track('Go to Chrome Store', splashID);
                    }}
                  >
                    Get it now
                  </button>
                  <button
                    type="button"
                    className="active:scale-95 inline-flex mt-3 justify-center w-full rounded-md border-0 px-4 py-2 bg-gray-100 text-sm font-medium text-gray-900 hover:bg-gray-200 transition-all duration-200 ease-in-out focus:outline-none outline-none select-none"
                    onClick={async () => {
                      await storageService.snoozeExtensionPrompt();
                      if (toolLink) { // only go to tool link if prompt was triggered by clicking on a tool
                        window.open(toolLink, '_blank');
                      }
                      setShow(false);
                    }}
                  >
                    Remind me later
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default DownloadExtensionPrompt;
